/**
 * Job statuses as pill tones. Done is success; waiting on something is warning; booked or
 * underway is info; everything else (proposed, under review, canceled, archived) is neutral.
 * Red is kept for danger, and no job status is one.
 */
export const jobStatusTone = (status: string) => {
  switch (status) {
    case 'Completed':
      return 'success' as const;
    case 'Incomplete':
    case 'Pend Sched':
    case 'Part on order':
    case 'Part on Order':
    case 'On Hold':
    case 'Delayed':
    case 'Quote Requested':
    case 'Pending Approval':
      return 'warning' as const;
    case 'Confirmed':
    case 'Locked In':
    case 'Enroute':
    case 'On Call':
    case 'In Progress':
      return 'info' as const;
    default:
      return 'neutral' as const;
  }
};
